<SidebarShell :logo="bolide_short_logo" brand_title="Infinity" brand_subtitle="" :initials="initials"
  :full_name="full_name" class="property-sidebar-shell">

  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <template #context>
    <SidebarContext :main_label="active_property?.title" :sub_label="active_property?.description"
      :items="propertiesFormatted" :active_id="active_property?.id" :open="dropdownOpen" @toggle="toggleDropdown"
      @select="switchProperty" class="w-100 p-0 m-0">
      <template #top>
        <div class="border-bottom border-secondary pb-2 mb-2 cursor-pointer w-100" style="cursor: pointer;"
          @click="backToGlobal">
          <p class="text-white fw-light text-xs mb-2">Executive View</p>
        </div>
      </template>
    </SidebarContext>
  </template>

  <template #menu>
    <div v-if="collapsed" class="px-3 mt-3 sidebar-menu-container">
      <template v-for="item in menuItems" :key="item.key">
        <div v-if="item.type === 'section' || item.type === 'accordion'" class="mt-2 text-white sidebar-section-group">
            <div class="collapsed-sidebar-group position-relative">
              <button
                type="button"
                class="collapsed-sidebar-trigger"
                :class="{ active: is_section_active(item) || isCollapsedGroupOpen(item.key) }"
                @click.stop="toggleCollapsedGroup(item.key)"
              >
                <i :class="item.icon"></i>
              </button>

              <div
                v-if="isCollapsedGroupOpen(item.key)"
                class="collapsed-sidebar-panel"
                @click.stop
              >
                <div class="collapsed-sidebar-panel-header border-bottom border-secondary pb-2 mb-2">
                  <p class="collapsed-sidebar-title mb-0">{{ item.label }}</p>
                </div>

                <div class="collapsed-sidebar-panel-list">
                  <div
                    v-for="child in item.children"
                    :key="child.key"
                    class="collapsed-sidebar-panel-item"
                    :class="{ active: active_menu_item === child.key }"
                    @click.stop="select_menu_item(child.key, child.label)"
                  >
                    <span>{{ child.label }}</span>
                    <span v-if="active_menu_item === child.key" class="active-dot"></span>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </template>
    </div>

    <div v-else class="px-3 mt-3 sidebar-menu-container">
      <template v-for="item in menuItems" :key="item.key">
        <div v-if="item.type === 'section' || item.type === 'accordion'" class="mt-2 text-white sidebar-section-group">
            <div class="d-flex align-items-center justify-content-between gap-2 sidebar-section-header"
              :class="{ active: is_section_active(item) }" style="cursor:default;">
              <div class="d-flex align-items-center gap-2">
                <i v-if="item.icon" :class="item.icon"></i>
                <span v-else class="text-xxs text-white-50 fw-semibold text-uppercase">{{ item.label }}</span>

                <span v-if="item.icon" class="sidebar-menu-text">
                  {{ item.label }}
                </span>
              </div>
            </div>

            <div class="ps-2 mt-2">
              <div v-for="child in item.children" :key="child.key"
                class="d-flex align-items-center gap-2 px-2 py-2 rounded-3 sidebar-menu-item"
                :class="{ active: active_menu_item === child.key }" role="button"
                @click.stop="select_menu_item(child.key, child.label)" style="cursor:pointer;">
                <i :class="child.icon"></i>
                <span class="text-xs sidebar-menu-text">{{ child.label }}</span>
              </div>
            </div>
        </div>

        <div v-else class="d-flex align-items-center gap-2 px-2 py-2 rounded-3 sidebar-menu-item"
          :class="{ active: active_menu_item === item.key }" @click="select_menu_item(item.key, item.label)"
          style="cursor:pointer;">
          <i :class="item.icon"></i>
          <span v-if="!collapsed" class="text-xs sidebar-menu-text">
            {{ item.label }}
          </span>
        </div>
      </template>
    </div>
  </template>

</SidebarShell>
